import { useCallback } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import FormCard from 'src/components/ui/FormCard';

import { useFormAreaParams } from '../hooks/useFormAreaParams';
import DefaultForm from '../DefaultForm';

const DefaultFormCAreaParams = (props) => {
	const {
		isPlain,
		onSubmit,
		onCancel,
		serverError,
		fullHeight,
		initialData,
		values,
		...rest
	} = props;

	const handleSubmit = useCallback(
		async (formValues) => {
			if (onSubmit) {
				await onSubmit(formValues, initialData);
			}
		},
		[onSubmit, initialData],
	);

	const { shape, initialValues, validationSchema } = useFormAreaParams({
		initialData,
		values,
	});

	const form = <DefaultForm {...shape} {...rest} />;

	if (isPlain) return form;

	let result = (
		<Formik
			onSubmit={handleSubmit}
			initialValues={initialValues}
			validationSchema={validationSchema}
			validateOnChange={false}
			enableReinitialize
		>
			{(formikProps) => {
				return (
					<FormCard
						title="Параметры площадки"
						error={serverError}
						fullHeight={fullHeight}
						onSubmit={formikProps.handleSubmit}
						onCancel={onCancel}
						onAccept={formikProps.dirty ? formikProps.submitForm : null}
						isLoading={formikProps.isSubmitting}
					>
						{form}
					</FormCard>
				);
			}}
		</Formik>
	);

	return result;
};

DefaultFormCAreaParams.propTypes = {
	...DefaultForm.propTypes,
	isPlain: PropTypes.bool,
	onSubmit: PropTypes.func,
	serverError: PropTypes.string,
	fullHeight: PropTypes.bool,
	initialData: PropTypes.object,
	values: PropTypes.object,
};

export default DefaultFormCAreaParams;
